import { FirebaseError } from 'firebase/app';
import { userFacingErrorMessage, type ErrorCode } from '@clinic/shared';

function isErrorCode(value: string): value is ErrorCode {
  return value in userFacingErrorMessage;
}

export function toPortugueseError(error: unknown, fallback: string): Error {
  if (error instanceof FirebaseError) {
    const details = (error as FirebaseError & { details?: { code?: unknown; errorCode?: unknown } })
      .details;
    const detailCode =
      typeof details?.errorCode === 'string'
        ? details.errorCode
        : typeof details?.code === 'string'
          ? details.code
          : '';
    if (isErrorCode(detailCode)) return new Error(userFacingErrorMessage[detailCode]);
    const firebaseCode = error.code.split('/').at(-1) ?? '';
    const authMessages: Record<string, string> = {
      'invalid-credential': 'E-mail ou senha incorretos.',
      'too-many-requests': 'Muitas tentativas. Aguarde alguns minutos e tente novamente.',
      'network-request-failed': 'Sem conexão com o servidor. Verifique sua internet.',
      unauthenticated: 'Entre novamente para continuar.',
      'permission-denied': 'Você não tem permissão para realizar esta ação.',
      unavailable: 'O serviço está temporariamente indisponível. Tente novamente.',
    };
    return new Error(authMessages[firebaseCode] ?? fallback);
  }
  return new Error(fallback);
}
